import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_ORGANIZATIONS_QUERY from './GetOrganizations.gql';

const parseResult = result => {
  const initialState = {
    organizations: [],
  };

  const providers = get(result, 'core.providerInformation');

  return {
    ...initialState,
    ...providers,
  };
};

export const useOrganizationsQuery = options => {
  const [queryResult, queryAction] = useQuery(GET_ORGANIZATIONS_QUERY, {
    ...options,
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
